/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { effects } from "./effects";
import { colors } from "./colors";
import { StyledText } from "../assets/typography/typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

const imageUrlStyle = css`
  min-width: 200px;
  min-height: 200px;
  width: 200px;
  height: 200px;
  border-radius: 4px;
  object-fit: contain;
`;

const previewWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 4px;
  width: fit-content;
  box-shadow: ${effects.cardRest};
`;

const leftContainer = css`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

const iconStyle = css`
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const cursorPointer = css`
  cursor: pointer;
`;

type Props = {
  url: string;
  children?: React.ReactNode;
  type?: "video" | "image" | "pdf";
};

export const BaseUploadPreview = ({ url, children, type = "image" }: Props) => {
  const pdfContainerStyle = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    background-color: ${colors.whiteHover};
    width: 100%;
    justify-content: space-between;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.08),
      0px 2px 2px 0px rgba(0, 0, 0, 0.08);
  `;

  if (type === "pdf") {
    return (
      <div css={pdfContainerStyle}>
        <div css={leftContainer}>
          <div css={iconStyle}>
            <FontAwesomeIcon icon={solid("check")} color={colors.textPrimary} />
          </div>
          <StyledText
            className="bodyTextSemibold mb-0"
            color={colors.textPrimary}
          >
            You have uploaded a file
          </StyledText>
        </div>
        <div css={iconStyle}>
          <FontAwesomeIcon
            icon={solid("external-link")}
            onClick={() => window.open(url, "_blank")}
            css={cursorPointer}
            color={colors.textPrimary}
          />
        </div>
      </div>
    );
  }

  return (
    <div css={previewWrapperStyle}>
      {type === "image" && <img css={imageUrlStyle} src={url} alt="preview" />}
      {type === "video" && (
        <video css={imageUrlStyle} controls>
          {/* type=video/mp4 works for both .mp4 and .mov */}
          <source src={url} type="video/mp4" />
        </video>
      )}
      {children && children}
    </div>
  );
};
